<div class="w-full flex justify-content-center">
  <div class="page-section page-section-x-padded">
    <ppg-inline-image [content]="content().image.content" />
    <ppg-rich-text [content]="text()" />
  </div>
</div>
